<template>
  <div class="hero-main-container" id="Hero">
    <img src="/Images/pexels-elletakesphotos-2101150 copy.jpg" alt="Hero Image" loading="eager">
    <div class="overlay"></div>
    
    <div class="hero-content">
      <h1 class="hero-title">Where Every Cup Tells a Story</h1>
      <p class="hero-subtitle">Freshly brewed coffee, warm atmosphere and a place you'll always come back to.</p>
      
      <div class="hero-buttons">
        <a href="#form"><button class="btn-primary">Reserve Now</button></a>
        <a href="#Menu"><button class="btn-secondary">View Our Menu</button></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hero',
  data() {
    return {
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Poppins:wght@400;500&display=swap');

.hero-main-container {
  width: 100%;
  height: 100vh;
  min-height: 600px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-main-container img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 3;
  text-align: center;
  max-width: 900px;
  padding: 0 2rem;
}

.hero-title {
  font-family: 'Playfair Display', serif;
  font-size: 54px;
  font-weight: 700;
  color: #F5F5DC;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.hero-subtitle {
  font-family: 'Poppins', sans-serif;
  font-size: 1.125rem;
  font-weight: 400;
  color: #F5F5DC;
  margin-bottom: 2.5rem;
  line-height: 1.6;
}

.hero-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.btn-primary {
  padding: 12px 2rem;
  background-color: #D4A574;
  color: #8B4513;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 600ms ease-in-out;
  white-space: nowrap;
}

.btn-primary:hover {
  background-color: rgba(111, 78, 55, 0.8);
  color: #D4A574;
  border: 1px solid #D4A574;
}

.btn-secondary {
  padding: 12px 2rem;
  background-color: rgba(111, 78, 55, 0.38);
  color: #D4A574;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid #D4A574;
  border-radius: 8px;
  cursor: pointer;
  transition: all 600ms ease-in-out;
  white-space: nowrap;
}

.btn-secondary:hover {
  background-color: rgba(212, 166, 116, 0.797);
  color: #8B4513;
}

/* Tablet Responsive */
@media (max-width: 1024px) {
  .hero-title {
    font-size: 48px;
  }
  
  .hero-subtitle {
    font-size: 1rem;
  }

  .hero-content {
    max-width: 750px;
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .hero-main-container {
    min-height: 550px;
  }

  .hero-content {
    padding: 0 1.5rem;
    max-width: 100%;
  }

  .hero-title {
    font-size: 38px;
    margin-bottom: 1.25rem;
  }
  
  .hero-subtitle {
    font-size: 0.95rem;
    margin-bottom: 2rem;
  }
  
  .hero-buttons {
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  }
  
  .btn-primary, .btn-secondary {
    width: 100%;
    max-width: 280px;
    padding: 13px 2rem;
  }
}

/* Small Mobile */
@media (max-width: 480px) {
  .hero-main-container {
    min-height: 500px;
  }

  .hero-content {
    padding: 0 1rem;
  }

  .hero-title {
    font-size: 32px;
    margin-bottom: 1rem;
  }
  
  .hero-subtitle {
    font-size: 0.9rem;
    margin-bottom: 1.75rem;
  }

  .btn-primary, .btn-secondary {
    font-size: 14px;
    padding: 11px 1.5rem;
  }
}

/* Landscape Mode for Mobile */
@media (max-width: 768px) and (orientation: landscape) {
  .hero-main-container {
    min-height: 100vh;
  }

  .hero-title {
    font-size: 34px;
  }

  .hero-subtitle {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }

  .hero-buttons {
    flex-direction: row;
  }

  .btn-primary, .btn-secondary {
    width: auto;
    padding: 10px 1.5rem;
    font-size: 14px;
  }
}
</style>